<template>
    <div class="video-play">
        <video id="video1" preload="auto"
               controls
               webkit-playsinline
               playsinline
               x-webkit-airplay="allow"
               x5-video-player-type="h5"
               autoplay="autoplay"
               x5-video-player-fullscreen="true"
               x5-video-orientation="portraint"
               style="width:100%;height:100%;object-fit:contain">
            <source :src="videoUrl" type="video/mp4">
        </video>
    </div>
</template>
<script>

    export default {
        name: "videoPlay",
        data() {
            return {
                videoUrl:""
            };
        },
        created() {
            let params = this.$route.query;
            const {videoUrl} = params;
            this.videoUrl = decodeURIComponent(videoUrl);
        },
    };
</script>
<style lang="less">
    .video-play {
        height: 100vh;
        text-align: center;
        display: flex;
        align-items: center;
        background: #000000;
        video{
            width: 100%;
        }
    }
</style>
